var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{ref:"filesList",staticClass:"files-list",attrs:{"id":_vm.$attrs.id,"options":_vm.filesListOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }